import { useCallback, useMemo, useState } from "react";
interface Actions {
  setTrue: () => void;
  setFalse: () => void;
}
export default function useBoolean(defaultValue: boolean): [boolean, Actions] {
  const [state, setState] = useState<boolean>(defaultValue);
  const setTrue = useCallback(() => {
    setState(true);
  }, []);
  const setFalse = useCallback(() => {
    setState(false);
  }, []);
  const action = useMemo(() => {
    return {
      setTrue,
      setFalse,
    };
  }, [setFalse, setTrue]);
  return [state, action];
}
